export default __webpack_public_path__ + "static/media/createColorful.34bd73b2.svg";